if (!Element.prototype.closest) { // полифил для ie11
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
        const el = this;
        let ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (ancestor.matches(s)) return ancestor;
            ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
    };
}

function unique(arr) {
    return Array.from(new Set(arr));
}

export var delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}());

export function isToFile() {
    return Number($('[name=to_file]').val());
}

export function rebuildBlocks() {
    const options = {
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
    };
    $_vikon('.block-item').matchHeight(options);
    $_vikon('.block-item-outer').matchHeight(options);
}
